import { createContext, useContext } from 'react';
export const SessionOperationContext = createContext(() => false);
export const useSessionOperationReady = () => useContext(SessionOperationContext);
